<template>
  <div class="add headFixed" @click="hideSomething">
    <HeadNav title="添加设备"></HeadNav>

    <!-- 填写识别码 -->
    <div>
      <img src="../../assets/images/bg.png" alt="" class="bgImg"/>
      <form>
        <ul class="writeInfo">


          <li v-show="eqType == 1">
            <label>设备名称:</label>
            <div><input type="text" v-model="name"/></div>
          </li>
          <li>
            <label>识别码:</label>
            <div><input type="text" v-model="number"/></div>
          </li>
          <li>
            <label>密&nbsp;&nbsp;&nbsp;码:</label>
            <div><input type="password" v-model="password" placeholder="密码6-8位" maxlength="8"/></div>
          </li>
          <li v-show="eqType == 1">
            <label>确认密码:</label>
            <div><input type="password" v-model="password2" placeholder="请于上次密码保持一致" maxlength="8"/></div>
          </li>
        </ul>
      </form>
      <div class="container addBtn">
        <mt-button size="large" type="primary" @click="handleMatch()">{{ btnText }}</mt-button>
      </div>
    </div>
  </div>
</template>
<script>
import {Toast, MessageBox} from 'mint-ui';
import HeadNav from '../headNav/headNav';

export default {
  name: 'add',
  data() {
    return {
      showWhrite: false,
      btnText: '开始匹配',
      list: [
        {
          name: '主机',
          list: [{warn: true}, {warn: true}]
        },
        {
          name: '风盘',
          list: [{warn: true}, {warn: true}]
        }
      ],
      password: null,
      password2: null,
      number: null,
      name: null,
      showDrop: false,
      eqType: 1
    };
  },
  mounted() {
    this.eqType = this.$route.query.type;
    this.numberDefault();
  },
  components: {
    HeadNav: HeadNav
  },
  methods: {
    numberDefault() {
      let str = '';
      let that = this;
      this.Api.eqText(str, msg => {
        if (msg.code == 200) {
          // alert(msg.data)
          if (msg.data != null && msg.data.length > 0) {
            MessageBox.confirm('检测到检测设备，是否使用此识别码?')
                .then(action => {
                  // alert(msg.data[0].number)
                  that.number = msg.data[0].number;
                })
                .catch(err => {
                  if (err == 'cancel') {
                  }
                });
          }
        }
      });
    },
    chooseItem(data) {
      this.showWhrite = true;
    },
    handleMatch() {
      let self = this;
      let eqType = this.eqType;
      if (eqType == 1) {
        if (!this.name) {
          Toast('请填写设备名称');
          return false;
        }
      }
      if (!this.number) {
        Toast('请填写识别码');
        return false;
      }
      if (!this.password) {
        Toast('密码不能为空');
        return false;
      }
      if (eqType == 1) {
        if (this.password != null && this.password.length < 6) {
          Toast('请确认密码长度');
          return false;
        }
        if (!this.password2) {
          Toast('请填写确认密码');
          return false;
        }
        if (this.password !== this.password2 && this.password != null) {
          Toast('两次密码不一致');
          return false;
        }
      }
      let data = {
        "number": this.number,
        "password": this.password,
        "type": this.eqType
      }
      this.Api.eqMatch(data, msg => {
        if (msg.code === 200) {
          self.handleNext();
        } else {
          Toast(msg.msg);
          self.btnText = '重新匹配';
        }
      });
    },
    addEq() {
      let params = {};
      params.number = this.number;
      params.name = this.name;
      params.password = this.password;
      params.roomId = '';
      params.useSceneId = '';
      params.type = this.eqType;
      this.Api.eqBind(params, msg => {
        if (msg.code == 200) {
          Toast('添加成功');
          localStorage.setItem('isLo', 1);
          this.$router.push({
            name: 'Equipment',
            params: {}
          });
        } else {
          Toast(msg.message);
        }
      });
    },
    handleNext() {
      var self = this;
      let eqType = this.eqType;
      if (eqType == 1) {
        if (!this.name) {
          Toast('请填写设备名称');
          return false;
        }
      } else {
        this.name = null;
      }
      if (!this.number) {
        Toast('请填写识别码');
        return false;
      }
      if (!this.password) {
        Toast('请填写密码');
        return false;
      }
      let params = {
        number: this.number,
        name: this.name,
        password: this.password,
        type: this.eqType,
      };
      console.log(params);
      this.Store.setEqInfo(params);
      self.$router.push({
        path: this.PATH.getChooseHome() + '1'
      });
    },
    handleReMatch() {
      Toast('重新匹配');
    },
    hideSomething() {
      this.showDrop = false;
    },
    dropToggle(e) {
      e.stopPropagation();
      this.showDrop = !this.showDrop;
    },
    changeEqType(type) {
      this.eqType = type;
      this.showDrop = !this.showDrop;
    }
  }
};
</script>

<style scoped>
@import url('./equipment.css');

.addBtn {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/equipment/add.vue